import con from "../../../../../connection";
var path = '/organizations';
export var organizations = function (url) { return function () {
    var fullPath = "" + url + path;
    return {
        get: function () { return con.get(fullPath, {}); },
    };
}; };
export default organizations;
